
import { getBackendSafeRoomName } from '../util';
import { checkIfReactNative } from '../util/checkOS';

/**
 * Builds and returns the room name.
 *
 * @param {string} locationUrl - Location URL.
 * @returns {string}
 */
export default function getRoomName(locationUrl: ?string): ?string {
    const path = checkIfReactNative() ? new URL(locationUrl)?.pathname : window?.location?.pathname;


    // The last non-directory component of the path (name) is the room.
    const roomName = path.substring(path.lastIndexOf('/') + 1) || undefined;

    if (checkIfReactNative()) {
        return roomName?.toLowerCase();
    }

    return getBackendSafeRoomName(roomName);
}
